import React from 'react';
import useEducators from './useEducators';

export default function useInactiveEducators(network, schoolStart, schoolEnd, currentTimestamp) {
  return useEducators(network, schoolStart, schoolEnd, {
    inactive: true
  });
}
